import { Button } from '@ui';
import { StyledCheckbox } from '@ui/Form';
import { first, last } from 'lodash';
import { useState } from 'react';
import { TableFieldAssistant } from '../FormFields/TableFieldAssistant';

// Rows hold slot *start* times, so the configured end time is one hour past the last slot
const endTimeFromRows = (rows: string[]) => {
    const lastRow = last(rows);
    if (!lastRow) return '00:00';

    return String(Number(lastRow.split(':')[0]) + 1).padStart(2, '0') + ':00';
};

// Edit dialog for an existing table field: seeds the assistant from the stored field and writes it back
const TableEditAssistant = ({ field, cb }) => {
    const rows = field.rows ?? [];
    const [values, setValues] = useState({
        startTime: first(rows) ?? '00:00',
        endTime: endTimeFromRows(rows),
        weekdays: field.columns ?? [],
        period: rows.some((row: string) => row.split(':')[1] === '30') ? 2 : 1,
        rows,
        minTimes: field.minTimes ?? 1,
        minDays: field.minDays ?? 1,
        rules: field.rules ?? []
    });
    const [inverted, setInverted] = useState<boolean>(!!field.inverted);

    return (
        <>
            <div className="tw-mb-4">
                <StyledCheckbox id="table-inverted" isSelected={inverted} onChange={setInverted}>
                    Schüler kreuzen an, wann sie nicht können
                </StyledCheckbox>
                <p className="tw-mb-0 tw-text-xs tw-text-accents-6">
                    Nicht angekreuzte Zeiten gelten im Trainingsplaner als verfügbar. Eine leere Tabelle heißt: kann
                    immer.
                </p>
            </div>
            <TableFieldAssistant
                withoutDisabledTimes={true}
                withoutMinimums={inverted}
                values={values}
                setValues={setValues}
            />
            <Button
                block
                color="success"
                onPress={() => {
                    if (inverted) {
                        // someone who can always ticks nothing, so minimums would block them
                        cb({
                            ...field,
                            inverted: true,
                            minTimes: 0,
                            minDays: 0,
                            rules: values.rules.filter(
                                (rule: string) => !rule.startsWith('min:') && rule !== 'required'
                            ),
                            rows: values.rows,
                            columns: values.weekdays
                        });
                        return;
                    }

                    const rules = values.rules?.map((rule) =>
                        rule.startsWith('min:') ? 'min:' + values.minTimes : rule
                    );
                    if (rules?.length === 0) {
                        rules.push('min:' + values.minTimes);
                    }

                    cb({
                        ...field,
                        inverted: false,
                        minTimes: values.minTimes,
                        minDays: values.minDays,
                        rules,
                        rows: values.rows,
                        columns: values.weekdays
                    });
                }}
            >
                Speichern
            </Button>
        </>
    );
};

export default TableEditAssistant;
